"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = require("I18n");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBreakString = _interopRequireDefault(require("UIComponents/text/UIBreakString"));

var _Filter = require("../../selectors/Filter");

var _Constants = require("../../Constants");

var _FileExtensionFilters = _interopRequireDefault(require("../../enums/FileExtensionFilters"));

var FilterHintMessage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FilterHintMessage, _Component);

  function FilterHintMessage() {
    (0, _classCallCheck2.default)(this, FilterHintMessage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterHintMessage).apply(this, arguments));
  }

  (0, _createClass2.default)(FilterHintMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          filterType = _this$props.filterType,
          filteredExtensions = _this$props.filteredExtensions,
          drawerType = _this$props.drawerType;
      return _react.default.createElement("div", {
        className: "m-y-2"
      }, _react.default.createElement(_UIBreakString.default, {
        hyphenate: false
      }, _react.default.createElement("span", {
        className: "m-right-1"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.filterHint.action." + drawerType
      })), _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.filterHint.message." + filterType,
        options: {
          extensions: (0, _I18n.formatList)(filteredExtensions.toArray()),
          count: filteredExtensions.count()
        }
      })));
    }
  }]);
  return FilterHintMessage;
}(_react.Component);

FilterHintMessage.propTypes = {
  drawerType: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  filteredExtensions: _propTypes.default.instanceOf(_immutable.default.Set).isRequired,
  filterType: _propTypes.default.oneOf(Object.keys(_FileExtensionFilters.default)).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    filterType: (0, _Filter.getFilterType)(state),
    filteredExtensions: (0, _Filter.getFilteredExtensions)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(FilterHintMessage);

exports.default = _default;
module.exports = exports.default;